import { prefixClassName } from 'framework/components/ui/_conf';

export const modalClass = prefixClassName('modal');

export const bp_md = 992;
